import React from 'react';
import { Button } from './ui/button';
import { Snowflake, Mountain, ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToConfigurator = () => {
    const element = document.getElementById('configurator');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 53, 128, 0.3), rgba(0, 53, 128, 0.4)), url('https://images.unsplash.com/photo-1551524559-8af4e6624178?w=1920&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 animate-float">
          <Snowflake size={60} className="text-white" />
        </div>
        <div className="absolute top-40 right-20 animate-float" style={{ animationDelay: '1s' }}>
          <Mountain size={80} className="text-white" />
        </div>
        <div className="absolute bottom-40 left-1/4 animate-float" style={{ animationDelay: '2s' }}>
          <Snowflake size={40} className="text-white" />
        </div>
        <div className="absolute bottom-60 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
          <Mountain size={50} className="text-white" />
        </div>
      </div>

      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          {/* Main Title - BLANCO */}
          <div className="space-y-4 animate-fade-in-up">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight drop-shadow-2xl">
              DESCUBRÍ LA MAGIA<br />DEL ESQUÍ EN ARGENTINA
            </h1>
            {/* Subtitle - CELESTE */}
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-[#87CEEB] leading-tight drop-shadow-lg">
              DISCOVER THE MAGIC<br />OF SKIING IN ARGENTINA
            </h2>
          </div>

          {/* Subtitle */}
          <div className="space-y-2 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <p className="text-xl md:text-2xl text-white font-semibold drop-shadow-lg">
              VIVÍ LA TEMPORADA INVERNAL EN ARGENTINA
            </p>
            <p className="text-lg md:text-xl text-[#87CEEB] font-medium drop-shadow-md">
              EXPERIENCE THE WINTER SEASON IN ARGENTINA
            </p>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-white max-w-3xl mx-auto leading-relaxed animate-fade-in-up drop-shadow-lg" style={{ animationDelay: '0.4s' }}>
            Descubrí los mejores centros de esquí de Argentina con la experiencia y confianza que nos caracteriza.
            <br />
            <span className="text-[#87CEEB]">Discover Argentina's best ski resorts with our trusted expertise.</span>
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
            <Button
              onClick={scrollToConfigurator}
              className="bg-[#FF6B35] hover:bg-[#E55A2B] text-white font-bold px-10 py-6 text-lg rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              CONFIGURÁ TU VIAJE AHORA / PLAN YOUR TRIP NOW
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-12 animate-bounce">
            <ChevronDown size={40} className="text-[#FF6B35] mx-auto drop-shadow-lg" />
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full">
          <path
            fill="#FFFFFF"
            fillOpacity="1"
            d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
